import * as React from 'react';
import { createContext } from 'react';
export const UserContext = createContext(null);
// todo: add usePermission-Hook
export const UserProvider = ({ children }) => {
    return <UserContext.Provider value={window.SitzkriegerUser}>
        {children}
    </UserContext.Provider>;
};
